import { ElementRef } from '@angular/core';
import scrollIntoView from 'scroll-into-view-if-needed';

export function focusFirstInvalidField(el: ElementRef) {
  if (!el) {
    return;
  }

  setTimeout(() => {
    const invalidElements = el.nativeElement.querySelectorAll(
      'ngx-intl-tel-input.ng-invalid input, input.ng-invalid, select.ng-invalid, textarea.ng-invalid'
    );

    if (invalidElements.length > 0) {
      const firstEl = invalidElements[0];
      scrollIntoView(firstEl, {
        behavior: 'smooth',
        scrollMode: 'if-needed',
      });
      firstEl.focus();
    }
  }, 0);
}
